export default {
    credit: '学分',
    classHour: '学时',
    todayTask: '我的学习任务',
    curriculum: '课程',
    special: '专题',
    examination: '考试',
    research: '调研',
    class: '班级',
    live: '直播',
    scjp: '认证考试',
    view: '人浏览过',
    anotherGroup: '换一组',
    more: '查看全部',
    branch: '分',
    door: '门',
    personTime: '人次',
    second: '次',
    views: '浏览人次',
    noStudent: '暂无学员上榜',
    goQuestion: '进入问吧',
    currentRanking: '您当前排名',
    location: '位',
    notRanking: '您暂无排名',
    studypack: '学习包',
    satisfactionEvaluation: '满意度评估',
};
